import { put, takeEvery } from 'redux-saga/effects';
import {
  fetchAllAddonsSuccess,
  fetchAllAddonsFailure,
  fetchOrgAddonsSuccess,
  fetchOrgAddonsFailure
} from 'redux/addons/actions';
import request from 'utils/request';
import urls from 'utils/config';
import AddonsActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

export function* fetchAllAddons() {
  const url = `${API_BASE_URL}/addons?page=0&size=10`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchAllAddonsSuccess(response.raw));
  } else {

    networkErrorHandler(response?.statusCode, `Failed to Fetch Addons: ${response.message}`);
    yield put(fetchAllAddonsFailure(response.message));
  }
}

export function* getAllAddons() {
  yield takeEvery(AddonsActionTypes.START_FETCH_ALL_ADDONS, fetchAllAddons);
}

export function* fetchOrgAddons() {
  const url = `${API_BASE_URL}/addons?page=0&size=10&enabled=true`;
  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchOrgAddonsSuccess(response.raw));
  } else {
    yield put(fetchOrgAddonsFailure(response.message));
  }
}

export function* getOrgAddons() {
  yield takeEvery(
    AddonsActionTypes.FETCH_ORG_ADDONS,
    fetchOrgAddons
  );
}